import React from 'react'

import {Avatar, Button, Drawer, Icon, Card, Checkbox, DatePicker, Col, notification, Popconfirm, Row, Select, Tooltip} from 'antd'
import _ from 'lodash'
import {hideLoader, showLoader} from '../../modules/actions'
import {TableComp} from 'sz-react-utils'
import Request from '../../request'
import {connect} from 'react-redux'
import moment from 'moment'
import LatestFollowUp from '../_utils/latestFollowup'
import Settings from '../_utils/settings'
import lodash from 'lodash'
import styles from './styles.less'

class InquiryStudents extends React.Component {
    state = {
        visible: true,        
        total: 0,
        ratingArr: ['Fit2Apply', 'Potential', 'Neutral', 'Cold', 'Dead', 'Active'],
        modeArr: [
            "Conopy",
            "Education Fair",
            "Facebook",
            "Google",
            "Instagram",
            "Justdial",
            "Newspaper",
            "Personal",
            "Seminar",
            "School/College Event",
            "Telephone",
            "Website",
            "Whatsapp",
        ],
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    apiRequest = param => {
        return new Promise(async resolve => {  
            
        const {dispatch, params} = this.props

          this.setState({exportParams: param}) 
          param.branchId = params.branchId
          param.counsellerId = params.counsellerId
          param.associatePartnerId = params.associatePartnerId
          param.countryId = params.countryId
          param.directCollegeId = params.directCollegeId
          param.indirectCollegeId = params.indirectCollegeId
          param.time = params.time
          param.type = params.type;

          let data = await Request.getStateEnquiries({
            ...param,
            regExFilters: [
              'studentName'
            ]
          });
          this.setState({total: data.total})
          resolve(data)
        })
    }

    renderStatus = (val) => {

        if (val === 'Super Hot') {
            return <div className={styles.SuperHot}>{val.toUpperCase()}</div>
        }
        if (val === 'Fit2Apply') {
            return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>
        }

        if (val === 'Neutral') {
            return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>
        }

        if (val === 'Potential') {
            return <div className={styles.Potential}>{val.toUpperCase()}</div>
        }

        if (val === 'Dead') {
            return <div className={styles.dead}>{val.toUpperCase()}</div>
        }

        if (val === 'Cold') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
        if (val === 'Active') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
    }
    
    returnDeskName = (val) => {
        const deskConfig = Settings.allDesks

        let findIn = lodash.find(deskConfig, (rr) => {
            return rr.name == val
        })

        if (findIn) {
            return <div style={{
                backgroundColor: findIn.color,
                color: 'white',
                padding: 3,
                display: 'inline-block',
                fontWeight: 'bold'
            }}>{Settings.deskNameObj[val]}</div>
        } else {
            return <div>{val}</div>
        }
    }

    render() {
        const {dispatch, params} = this.props
        const { ratingArr, modeArr, total } = this.state
        const columns = [
            {
                title: 'Photo',
                key: 'profilePic',
                width: 55,
                dataIndex: 'profilePic',
                render: val => {

                    return (
                        <Avatar src={val}/>
                    )
                }
            },
            {
                title: 'ID',
                key: 'id',
                width: 100,
                dataIndex: 'id',
                sorter: true,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: 'Student Name',
                key: 'studentName',
                width: 110,
                dataIndex: 'studentName',
                sorter: true,
                searchTextName: 'studentName',
                filterRegex: true,
                render: (item, record) => {
                    return (
                        <React.Fragment>
                            <div
                            >
                            <Tooltip>
                                <a target={'_blank'}
                                   href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                >{item}</a>
                            </Tooltip>
                            </div>
                        </React.Fragment>

                    )
                }
            },
            {
                title: 'At Stage',
                key: 'atLevel',
                dataIndex: 'atLevel',
                width: 150,
                sorter: true,
                render: (val, record) => {
                    return (
                        this.returnDeskName(val)
                    )
                }
            },
            {
                title: 'Registration Date',
                width: 100,
                key: 'moveDeskDate.moveToRegistrationDesk',
                dataIndex: 'moveDeskDate.moveToRegistrationDesk',
                width: 140,
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('lll') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'DOB',
                width: 100,
                sorter: true,
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                searchTextName: 'D-M-Y(05-05-1997)',
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Mobile',
                width: 100,
                key: 'mobile',
                dataIndex: 'mobile',
                searchTextName: 'mobile',
                filterRegex: true
            },
            {
                title: 'WhatsApp',
                width: 110,
                key: 'watsupp',
                dataIndex: 'watsupp',
                searchTextName: 'watsupp',
                filterRegex: true, render: (val, record) => {

                    return (
                        val && val.length == 10 ?
                            <Tooltip title="Share on Whatsapp">
                                <a target={'_blank'}
                                   style={{textDecoration: 'underline'}}
                                   href={`http://api.whatsapp.com/send?phone=${val}&text=&source=&data=`}>{val}</a></Tooltip>
                            : val
                    )
                }
            },
            {
                title: 'Mode',
                width: 100,
                key: 'mode',
                filters: modeArr && modeArr.map(x => ({value: x, text: x}))
            },
            {
                title: 'Rating',
                width: 100,
                key: 'counsellingDesk.rating',
                filters: ratingArr && ratingArr.map(x => ({value: x, text: x})),
                render: (val, record) => {
                    return this.renderStatus(val)

                }
            },
            {
                title: 'Preference',
                key: 'preference',
                width: 110,
                searchTextName: 'preference',
                filterRegex: true,
                render: (val, row) => {
                    return row.totalPreference ? (
                        <ul>
                            {row.totalPreference.map((val, inde) => {
                                return <li key={inde}>{val.country}</li>
                            })}
                        </ul>
                    ) : null
                }
            },
            {
                title: 'Follow Up',
                key: 'followUp',
                width: 200,
                dataIndex: 'followUp',
                render: (text, record) => {
                    return <LatestFollowUp info={text}/>
                }
            },
            {
                title: 'Last Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div>{text ? text.name : ''}</div>
                            <small>{text ? moment(text.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
        ];
      
        return (
            <Drawer
                title={
                    <div>
                        {'Report of '} {params.type} { '(' + total + ')' }
                        <a onClick={this.onClose} style={{float: 'right', color: 'black'}}>
                            <Icon type={'close'}/>
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                <TableComp
                    ref={this.table}
                    columns={columns}
                    apiRequest={this.apiRequest}
                    extraProps={{scroll: {x: 900}}}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 20,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                    }}
                />
                </Card>
            </Drawer>
        )
    }
}
  
const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InquiryStudents)